import React from 'react';
import { Box, Text, Link, HStack, Icon, VStack } from '@chakra-ui/react';
import { FaInstagram, FaWhatsapp } from 'react-icons/fa';

const Footer = () => {
  return (
    <Box bg="gold.500" color="black" py={4} textAlign="center" w="100%">
      <VStack spacing={2}>
        <HStack justify="center" spacing={8} mb={2} wrap="wrap">
          <Link href="https://www.instagram.com/cdempilhadeiras" isExternal color="black" _hover={{ textDecoration: "underline" }}>
            <HStack justify="center" align="center">
              <Icon as={FaInstagram} w={6} h={6} />
              <Text fontWeight="bold">@cdempilhadeiras</Text>
            </HStack>
          </Link>
          <Link href="https://wa.me//5581985771555?text=Ol%C3%A1,%20peguei%20o%20contato%20no%20site%20da%20CD%20Empilhadeiras" isExternal color="black" _hover={{ textDecoration: "underline" }}>
            <HStack justify="center" align="center">
              <Icon as={FaWhatsapp} w={6} h={6} />
              <Text fontWeight="bold">81 98577-1555</Text>
            </HStack>
          </Link>
        </HStack>
        <Text mt={1} fontSize={{ base: 'sm', md: 'md' }} fontWeight="bold">
          Desenvolvido por <Link href="https://wa.me//5519988270809?text=Ol%C3%A1,%20peguei%20o%20contato%20no%20site%20da%20CD%20Empilhadeiras" isExternal color="black" _hover={{ textDecoration: "underline" }}>Cesar Menegatti</Link>
        </Text>
      </VStack>
    </Box>
  );
};

export default Footer;
